import { createContext, ReactElement, useContext, useState } from 'react';
import { LoadingScreen } from '../../shared/components/LoadingScreen';

export const LoadingContext = createContext({
    isLoading: false,
    setIsLoading: (_loading: boolean) => {},
});

export const LoadingContextProvider = ({ children }: { children: ReactElement }) => {
    const [isLoading, setIsLoading] = useState(false);

    return (
        <LoadingContext.Provider
            value={{
                isLoading,
                setIsLoading,
            }}
        >
            {isLoading && <LoadingScreen />}
            {children}
        </LoadingContext.Provider>
    );
};

export const useLoadingProvider = () => useContext(LoadingContext);
